// 환자관리 기능 잠금 게이트 — 이용약관 v7.0 제4조의7 14항 (2026-10-06 코드 준비, 시행 2026-11-06 후에만 동작)
// App.js 가 /patients·/patients/:pid·/reception·/clinic-recalls·/settings/feedback·/settings/roadmap·/settings/walkin-qr 를 감싼다.
// required(utils/delegationV70.js useDelegationV70)가 true 면 자식 대신 안내 + [확인하기](MainLayout 모달 요청). 직원은 대표 안내만.
// 그 밖의 라우트는 건드리지 않는다(14항 "그 밖의 서비스 이용에는 영향이 없습니다").
import React from 'react';
import { requestDelegationV70Modal } from '../../utils/delegationV70';

function DelegationV70Gate({ required, isStaff, loading, error, reload, children }) {
    if (!required) return children;
    return (
        <div style={G.wrap}>
            <div style={G.title}>{'환자 관리 기능은 이용약관 제4조의7 재확인 후 열립니다'}</div>
            {loading ? (
                <div style={G.sub}>{'확인 상태를 불러오는 중…'}</div>
            ) : isStaff ? (
                <>
                    <div style={G.sub}>{'이용약관 v7.0 시행으로 환자 개인정보 처리위탁 조항(제4조의7)이 바뀌었습니다. 치과 대표 계정이 바뀐 내용을 확인해야 환자 관리 기능을 쓸 수 있습니다. 대표에게 알려 주세요. 그 밖의 기능은 그대로 쓸 수 있습니다.'}</div>
                    {error && <div style={G.err}>{error}</div>}
                    <div style={G.row}>
                        <button type="button" onClick={requestDelegationV70Modal} style={G.btnS}>{'바뀐 내용 보기'}</button>
                        <button type="button" onClick={reload} style={G.btnS}>{'다시 확인'}</button>
                    </div>
                </>
            ) : (
                <>
                    <div style={G.sub}>{'이용약관 v7.0 시행으로 환자 개인정보 처리위탁 조항(제4조의7)이 바뀌었습니다. 바뀐 내용을 확인하면 환자 관리 기능이 바로 열립니다. 확인하지 않아도 그 밖의 기능은 그대로 쓸 수 있습니다.'}</div>
                    <div style={G.row}>
                        <button type="button" onClick={requestDelegationV70Modal} style={G.btnP}>{'바뀐 내용 확인하기'}</button>
                    </div>
                </>
            )}
        </div>
    );
}

const G = {
    wrap: { maxWidth: 560, margin: '60px auto', background: '#FFFBEB', border: '1px dashed #f59e0b', borderRadius: 14, padding: '28px 24px', textAlign: 'center' },
    title: { fontSize: 16, fontWeight: 800, color: '#0f172a', marginBottom: 8 },
    sub: { fontSize: 13, color: '#475569', lineHeight: 1.65, wordBreak: 'keep-all' },
    err: { marginTop: 10, fontSize: 12.5, color: '#8a2020', background: '#fdecec', border: '1px solid #f5cfcf', borderRadius: 8, padding: '8px 11px' },
    row: { display: 'flex', justifyContent: 'center', gap: 8, marginTop: 14 },
    btnP: { padding: '9px 18px', background: '#0f6b5c', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13.5, fontWeight: 700, cursor: 'pointer' },
    btnS: { padding: '9px 16px', background: '#fff', color: '#475569', border: '1px solid #cbd5e1', borderRadius: 8, fontSize: 13.5, fontWeight: 600, cursor: 'pointer' },
};

export default DelegationV70Gate;
